import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import {
  COMPANY_STATUSES,
  NO_BIZ,
  CREDIT_HOLD,
  OBSOLETE
} from "../../constants";

const STATUS_FIELDS = ["status", "vendor_status", "repair_station_status"];

const STATUS_LABELS = {
  [NO_BIZ]: {
    label: "label-danger",
    text: COMPANY_STATUSES[NO_BIZ].label
  },
  [CREDIT_HOLD]: {
    label: "label-danger",
    text: COMPANY_STATUSES[CREDIT_HOLD].label
  },
  [OBSOLETE]: {
    label: "label-danger",
    text: COMPANY_STATUSES[OBSOLETE].label
  }
};

function StatusLabel({ label, text }) {
  return (
    <span className={`pull-right label ${label}`}>
      <i className="fa fa-warning" />
      &nbsp;&nbsp;{text}
    </span>
  );
}

StatusLabel.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default function StatusBadges({ company }) {
  const statuses = STATUS_FIELDS.map(field => STATUS_LABELS[company.get(field)])
    .filter(label => label) // Remove nulls
    .map(label => (
      <StatusLabel key={label.text} label={label.label} text={label.text} />
    ));

  return <div className="pull-right">{statuses}</div>;
}

StatusBadges.propTypes = {
  company: PropTypes.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/StatusBadges.jsx